export default __webpack_public_path__ + "static/media/swipe-landing_1.1a107d67.png";